import React, { useMemo, useState } from 'react';

import { Dropdown } from 'semantic-ui-react';

import { computeFeatureHistograms } from './helpers';
import { FILTER_FEATURES_BY } from '../constants';
import { useModelFeatures } from '../hooks/useModelData';

export const useComputedHistograms = (rawData, trainingData) => {
  const { modelFeatures, features, channels } = useModelFeatures(rawData, FILTER_FEATURES_BY);

  const allHistograms = useMemo(() => (
    rawData && modelFeatures
      ? computeFeatureHistograms(rawData, trainingData, modelFeatures)
      : {}
  ), [rawData, modelFeatures]);

  return {
    allHistograms,
    features,
    channels,
  };
};

export const useKPIAndTargetSelection = isConversionKPI => {
  const [targetRoas, setTargetRoas] = useState(1.5);
  const [chartType, setChartType] = useState('kpi');

  /* eslint-disable no-param-reassign */
  const changeMetric = (minMetric, maxMetric, value) => {
    if (value < minMetric) value = minMetric;
    if (value > maxMetric) value = maxMetric;
    const updatedValue = isConversionKPI ? 1 / value : value;
    setTargetRoas(updatedValue);
  };
  /* eslint-enable no-param-reassign */

  const ChartTypeSelector = () => (
    <Dropdown
      compact
      selection
      options={[
        {
          text: `Predicted ${isConversionKPI ? 'Conversions' : 'Revenue'} by Spend Level`,
          value: 'kpi',
        },
        {
          text: `${isConversionKPI ? 'CPA' : 'ROAS'} by Spend Level`,
          value: 'metric',
        },
      ]}
      value={chartType}
      onChange={(e, { value }) => setChartType(value)}
      style={{ width: 245 }}
    />
  );

  return {
    targetRoas,
    setTargetRoas,
    chartType,
    setChartType,
    changeMetric,
    ChartTypeSelector,
  };
};
